
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.402.992H3.795a1.402 1.402 0 00-1.402 1.401v11.214c0 .77.631 1.401 1.402 1.401h8.41a1.402 1.402 0 001.402-1.401v-8.41L9.402.992z"}}),_c('path',{attrs:{"d":"M6.598 5.898H5.197m4.205-4.205v3.504h3.504L9.402 1.693zM10.803 8.7H5.197h5.606zm0 2.803H5.197h5.606z"}})])
          )
        }
      }
    